<template>
<el-dialog custom-class="readFail-dialog" :visible.sync="readFailVisible" width="30%" @close='closeReadFailBox' center>
  <span slot="title">
    <img class="readFail-img" src="../../../assets/logo1-m@1x.png" alt="">
  </span>
  <div class="readBox-body">
    <h1 class="read-title">Only for VIP members</h1>
    <p class="read-info">Each account only can have free trial once. Want more information or service? Please contact us.</p>
    <el-button class="read-button" @click="toContactus">Contact us</el-button>
  </div>
</el-dialog>
</template>

<script>
export default {
  name: 'readFail',
  componentName: 'readFail',
  data() {
    return {
      readFailVisible: false
    }
  },
  methods: {
    closeReadFailBox() {
      // this.$store.commit('readFailVisible', false)
    },
    toContactus() {
      this.$router.push('/Contactus');
      this.closeReadFailBox()
    }
  }
}
</script>

<style lang="scss">
.readFail-dialog {
  border-radius:0.625rem;

  .el-dialog__body {
    padding: 30px 35px;
    padding-top: 0;
    margin-top: -2.5rem;
  }

  .el-dialog__header {
    height: 10.125rem;
    background: url('../../../assets/loginbk-m@1x.png') center center no-repeat;
    background-size: 100% 90%;

    .readFail-img {
      margin-top: 2rem;
    }
  }
}

.readBox-body {
  text-align: center;

  .read-title {
    font-size: 1.875rem;
    color:#0F2C4F;
  }

  .read-info {
    font-size: 1rem;
    line-height: 1rem;
    color:#9EB2CD;
    margin-bottom: 3.75rem;
  }

  .read-button {
    width: 92%;
    background-color: #0F2C4F;
    height:2.75rem;
    font-size:1.125rem;
    font-weight:500;
    color:#fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/readFail/src/main.vue